<template>
  <svg width="17"
       height="16"
       viewBox="0 0 17 16"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M8.40625 0L10.8438 5.48438L16.8125 6.125L12.3594 10.1406L13.6094 16L8.40625 13L3.21875 16L4.45312 10.1406L0 6.125L5.96875 5.48438L8.40625 0Z"
          fill="#DE9D3C" />
  </svg>
</template>
